import {
  UsersApiClientUrlsInterface,
  UsersApiClientInterface,
  UsersApiClientModel,
} from '../../../models/api-client/models/users';

const urls: UsersApiClientUrlsInterface = {
  loginUser: 'http://localhost:8000/users',
  logoutUser: 'http://localhost:8000/contacts',
};

const UsersApiClient: UsersApiClientInterface = new UsersApiClientModel({
  urls,
});
export {UsersApiClient};
